<template>
  <v-menu :close-on-content-click="false">
    <template v-slot:activator="{ on }">
      <v-btn icon v-on="on">
        <v-icon>
          mdi-dots-vertical
        </v-icon>
      </v-btn>
    </template>
    <v-list dense>
      <v-list-item @click="goToEditCompra(compra)" :disabled="isEditDisabledCancelada(compra)">
        <v-list-item-content>
          <div>
            <v-icon>mdi-pencil</v-icon>
            Editar compra
          </div>
        </v-list-item-content>
      </v-list-item>
      <px-atualizar-moeda-dialog v-if="isMoedaEstrangeira" :compra="compra" @change="emitChange">
        <template v-slot:activator="{ on }">
          <v-list-item v-on="on">
            <v-list-item-content>
              <div>
                <v-icon>mdi-currency-usd</v-icon>
                Atualizar moeda
              </div>
            </v-list-item-content>
          </v-list-item>
        </template>
      </px-atualizar-moeda-dialog>
      <v-list-item @click="gerarPdf(compra)" :disabled="loadingPdf">
        <v-list-item-content>
          <div>
            <v-icon>mdi-file-pdf-box</v-icon>
            Gerar PDF
            <v-progress-circular
              class="ml-3"
              :size="20"
              :width="3"
              v-if="loadingPdf"
              indeterminate
              color="primary"
            ></v-progress-circular>
          </div>
        </v-list-item-content>
      </v-list-item>
      <v-list-item @click="reenviarEmail" :disabled="loadingEmail || enviadoEmail">
        <v-list-item-content>
          <div>
            <v-icon :disabled="enviadoEmail">mdi-email-outline</v-icon>
            Reenviar e-mail
          </div>
        </v-list-item-content>
      </v-list-item>
      <v-list-item @click="reenviarWhatsapp" :disabled="loadingWhatsapp || enviadoWhats">
        <v-list-item-content>
          <div>
            <v-icon :disabled="enviadoWhats">mdi-whatsapp</v-icon>
            Reenviar whatsapp
          </div>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import { SituacaoCompra } from 'px-business-components';
import moedaMixin from '@/mixins/moeda-mixin';
import AtualizarMoedaDialog from '@/modules/compra/edicao/AtualizarMoedaDialog.vue';
import CompraService from '../compra-service';

export default {
  mixins: [moedaMixin],
  props: {
    compra: Object,
  },
  data() {
    return {
      loadingWhatsapp: false,
      loadingPdf: false,
      loadingEmail: false,
      enviadoWhats: false,
      enviadoEmail: false,
    };
  },
  computed: {
    moeda() {
      return this.compra.moeda;
    },
    isEditDisabledCancelada() {
      return item => [
        SituacaoCompra.keys.CANCELADA.key,
        SituacaoCompra.keys.ELABORACAO.key,
        SituacaoCompra.keys.RECUSADA.key,
        SituacaoCompra.keys.RASCUNHO.key,
        SituacaoCompra.keys.AGUARDANDO_APROVACAO_INTERNA.key,
      ].includes(item.situacao);
    },
  },
  methods: {
    reenviarWhatsapp() {
      this.loadingWhatsapp = true;
      CompraService.reenviarWhatsapp(this.compra.id)
        .then(() => {
          this.$toast('Whatsapp reenviado com sucesso!', { color: 'success' });
          this.enviadoWhats = true;
        })
        .finally(() => {
          this.loadingWhatsapp = false;
        });
    },
    reenviarEmail() {
      this.loadingEmail = true;
      CompraService.reenviarEmail(this.compra.id)
        .then(() => {
          this.$toast('Email reenviado com sucesso!', { color: 'success' });
          this.enviadoEmail = true;
        })
        .finally(() => {
          this.loadingEmail = false;
        });
    },
    goToEditCompra(item) {
      this.$router.push({
        name: 'main.compras.edicao',
        params: {
          id: item.id,
        },
        query: {
          isRascunho: false,
          isCopy: false,
        },
      });
    },
    gerarPdf(compra) {
      this.loadingPdf = true;
      return CompraService.generatePdf(compra.id)
        .then(({ data }) => {
          const blob = new Blob([data], { type: 'application/pdf' });
          const objectUrl = URL.createObjectURL(blob);
          window.open(objectUrl);
        })
        .finally(() => {
          this.loadingPdf = false;
        });
    },
    emitChange() {
      this.$emit('change');
    },
  },
  components: {
    pxAtualizarMoedaDialog: AtualizarMoedaDialog,
  },
};
</script>
